import { axios, API } from "@/imports-files/common/common";
import {SendRequest} from '@/services/common/send-request';

export class MyInterviewWidgetService extends SendRequest
{
    
    async setInterviewData(params)
    {
        const url = API.VIDEO_QA_INTERVIEW.SET_CANDIDATE_INTRODUCTION;
        try {
             const result = await axios.post( url,
               params,
              this.setHeaderJSON(),
              this.setCrossDomainTrue(),
              this.setCredentialsJSON());
            return result;
          } catch (error) {
            return error;
          }
    }

    async setInterviewVideo(params)
    {
        const url = API.VIDEO_QA_INTERVIEW.UPDATE_VIDEO_QA;
        try {
             const result = await axios.post( url,
               params,
              this.setHeaderJSON(),
              this.setCrossDomainTrue(),
              this.setCredentialsJSON());
            return result;
          } catch (error) {
            return error;
          }
    }
}